// Auto-generated by scripts/version.mjs. Do not edit.
export const APP_VERSION = '463f7806a9';
export const APP_VERSION_FULL = '463f7806a954a0ddbea02c5e76185d7c0766bff9';
export const APP_BUILT_AT = 1780770303188;
